import { Navigate } from 'react-router';

import { useTypedParams } from '@sorare/routing';
import { ANY_SPORT_PLAY_EVENTTYPE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { PageParams } from './__generated__/routeParams.ts';

const LeaderboardPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { eventType } = useTypedParams<PageParams>();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_PLAY_EVENTTYPE, {
        params: {
          eventType,
        },
      })}
      replace
    />
  );
};

export default LeaderboardPage;
